import { passwordLetterRegex, passwordNumberRegex, passwordRegex as validPasswordPattern } from '@constants/validation';
import { Ref, unref } from 'vue';
import { helpers } from '@vuelidate/validators';
import { ValidationRule } from '@vuelidate/core';

export const passwordRegex = (): ValidationRule => {
	return helpers.withParams({ type: 'passwordRegex' }, (value: string | Ref<string>): boolean => {
		const pattern = new RegExp(validPasswordPattern);
		return pattern.test(unref(value));
	});
};

export const passwordContainsLetter = (): ValidationRule => {
	return helpers.withParams({ type: 'passwordContainsLetter' }, (value: string | Ref<string>): boolean => {
		const pattern = new RegExp(passwordLetterRegex);
		return pattern.test(unref(value));
	});
};

export const passwordContainsNumber = (): ValidationRule => {
	return helpers.withParams({ type: 'passwordContainsNumber' }, (value: string | Ref<string>): boolean => {
		const pattern = new RegExp(passwordNumberRegex);
		return pattern.test(unref(value));
	});
};
